module.exports = __webpack_public_path__ + "img/daySmarters.47c1bf64.png";